import React, { useEffect, useState } from "react";
import defaultPerfil from "../../../assets/images/generico/defaultUserImage.png";
import { useHistory, useLocation } from "react-router";
import { resetMultitab } from "../../../context/Actions/multiTab/multiTab";
import { useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import { logoutApp } from "../../../../global/context/action/auth/logoutApp";
import { logoutPaciente } from "../../../context/Actions/paciente/paciente";
import { tokenLogout } from "../../../context/Actions/token/logoutToken";
import { misMedicosReset } from "../../../context/Actions/misMedicos/misMedicos";
import { misInformesReset } from "../../../context/Actions/misInformes/misInformes";
import { misLaboratoriosReset } from "../../../context/Actions/misLaboratorios/misLaboratorios";
import { resetTurnosPaciente } from "../../../context/Actions/turnos/turnosPaciente";
import { grupoFamiliarReset } from "../../../context/Actions/grupoFamiliar/grupoFamiliar";
import { localidadReset } from "../../../context/Actions/localidad/localidad";
import { resetLaboGrupo } from "../../../context/Actions/laboGrupo/laboGrupo";
import { resetEstudioGrupo } from "../../../context/Actions/estudioGrupo/estudioGrupo";
import { resetListaFamiliares } from "../../../context/Actions/listaFamiliares/listasFamiliares";
import { recetasDigitalesReset } from "../../../context/Actions/turnos/recetaDigital";
import { resetDropdown } from "../../../context/Actions/DropDownFamiliares/selectFamiliares";
import { dispositivoPacienteReset } from "../../../context/Actions/dispositivoPaciente/dispositivoPaciente";
import { GlobalContext } from "../../../../global/context/Provider";
import {
  BodyMenu,
  ComboMenu,
  ContainerMenu,
  Image,
  TextTopMenu,
  TopMenu,
} from "./localStyle";
import { Link } from "react-router-dom";
import SocialSidebar from "../SocialSidebar/SocialSidebar";
import { wsPostLogoutTraza } from "global/context/action/auth/loginTraza";
import { listItems } from "./BuergerMobileFun";
import routes from "_+_Portal/routes/listRoutes";
import ConsultaMedica from "_+_Portal/pages/ConsultaMedica/ConsultaMedica";
import Estudios from "_+_Portal/pages/Estudios/Estudios";
import Laboratorio from "_+_Portal/pages/Laboratorio/Laboratorio";
import { isNativeIOS, isNativeMobile, isWeb } from "../../../../global/utils/platformDetector";
import CrossLucideIcon from "_+_Portal/assets/images/generico/CrossLucideIcon";
import ChevronRightIcon from "_+_Portal/assets/images/generico/ChevronRightIcon";
import "./BurguerMobile.css";

const BurguerMobile = ({
  onCloseBurguerMobile,
  showBurguerMobile,
  nextFnc,
}) => {
  //#region  legacy code
  const {
    multiTabDispatch,
    pacienteDispatch,
    misMedicosDispatch,
    misInformesDispatch,
    misLaboratoriosDispatch,
    turnosPacienteDispatch,
    grupoFamiliarDispatch,
    localidadDispatch,
    laboGrupoDispatch,
    estudioGrupoDispatch,
    listaFamiliaresDispatch,
    tokenDispatch,
    recetasDigitalesDispatch,
    selectDropDownDispatch,
    dispositivoPacienteDispatch,
    resetPortalContext,
  } = useContext(PortalContext);

  // Cambio de contexto
  const { authState, authDispatch, configState, resetGlobalContext } =
    useContext(GlobalContext);
  //#region ------ constants ------
  const imgAvatar =
    authState.auth.data !== null && authState.auth.data.paciente !== null
      ? authState.auth.data.paciente?.imagenPerfil
      : "";
  const history = useHistory();
  const url = useLocation().pathname;
  const isIOS = isNativeIOS();
  const isWebPlatform = isWeb();
  //#endregion ------ constants ------

  //#region ------ useState ------
  const [itemSelected, setItemSelected] = useState({ 0: 0 });
  const [renderedItems, setRenderedItems] = useState(null);
  //#endregion --- useState ------

  //#region --------- functions ------
  const onHandleSalir = () => {
    if (authState.authTraza.data !== null) {
      wsPostLogoutTraza(authState.authTraza.data.id, {
        ingreso: false,
        sector: configState.config.data.sectorTurno,
      })(authDispatch);
    }
    if (configState.config.data.opcResetContext) {
      localStorage.removeItem("token");
      localStorage.removeItem("auth");
      localStorage.removeItem("idApp");
      localStorage.removeItem("idPaciente");
      resetGlobalContext(0);
      resetPortalContext(0);
    } else {
      logoutPaciente(history)(pacienteDispatch);
      tokenLogout(history)(tokenDispatch);
      misMedicosReset()(misMedicosDispatch);
      misInformesReset()(misInformesDispatch);
      misLaboratoriosReset()(misLaboratoriosDispatch);
      resetTurnosPaciente()(turnosPacienteDispatch);
      grupoFamiliarReset()(grupoFamiliarDispatch);
      localidadReset()(localidadDispatch);
      resetMultitab()(multiTabDispatch);
      resetLaboGrupo()(laboGrupoDispatch);
      resetEstudioGrupo()(estudioGrupoDispatch);
      resetListaFamiliares()(listaFamiliaresDispatch);
      recetasDigitalesReset()(recetasDigitalesDispatch);
      resetDropdown()(selectDropDownDispatch);
      dispositivoPacienteReset()(dispositivoPacienteDispatch); // ✅ Reset del estado de dispositivo
      localStorage.removeItem("token");
      localStorage.removeItem("auth");
      localStorage.removeItem("idApp");
      localStorage.removeItem("idPaciente");
      sessionStorage.token = "";
      sessionStorage.auth = "";
    }
    logoutApp(history)(authDispatch);
  };

  const navigate = (path) => {
    if (path.link === "/atencionSinTurno" && isNativeMobile()) {
      sessionStorage.setItem("pasoInicialAutocheckin", "AtencionSinTurnoSelect");
      if (window.location.pathname !== "/autocheckin") {
        history.push("/autocheckin");
      }
      window.dispatchEvent(new CustomEvent("setPasoInicialAutocheckin"));
      if (nextFnc) nextFnc();
      return;
    }
    if (
      configState.config.data.opcBuscadorTurnos &&
      (path.link === "/consultamedica" ||
        path.link === "/estudios" ||
        path.link === "/laboratorio")
    ) {
      let idComparador = 0;
      if (path.link === "/consultamedica") {
        idComparador = 9;
      } else if (path.link === "/estudios") {
        idComparador = 10;
      } else {
        idComparador = 11;
      }
      const index = routes.findIndex((objeto) => objeto.id === idComparador);
      if (index === -1) {
        routes.push(
          {
            id: 9,
            path: "/consultamedica",
            component: ConsultaMedica,
            title: "Buscador Consulta Médica",
            needsAuth: true,
          },
          {
            id: 10,
            path: "/estudios",
            component: Estudios,
            title: "Buscador Estudio",
            needsAuth: true,
          },
          {
            id: 11,
            path: "/laboratorio",
            component: Laboratorio,
            title: "Buscador Laboratorio",
            needsAuth: true,
          }
        );
      }
    }
    history.push(path.link);
    // Solo ejecutar nextFnc si navegamos al autocheckin (para resetear el paso a Home)
    if (nextFnc && path.link === "/autocheckin") {
      nextFnc();
    }
  };
  //#endregion --------- functions ------

  //#region ------ useEffect ------
  useEffect(() => {
    if (renderedItems !== null) {
      renderedItems.contents.map((content, index1) => {
        content.map((item, index2) => {
          const element = item;
          if (element.link === url) {
            setItemSelected({ [index1]: index2 });
          }
        });
      });
    }
    let cursor = false;
    let cursory = false;

    window.ontouchstart = (e) => {
      cursor = e.changedTouches[0].clientX;
      cursory = e.changedTouches[0].clientY;
    };

    window.ontouchend = (e) => {
      cursor = cursor - e.changedTouches[0].clientX;
      cursory = cursory - e.changedTouches[0].clientY;
      // if(cursor < 0) onCloseBurguerMobile();
      if (cursor > 0 && cursory < 20 && cursory > -20) {
        // onCloseBurguerMobile("open");
      } else if (cursor < 0 && cursory < 20 && cursory > -20) {
        onCloseBurguerMobile();
      }
    };
  }, []);

  useEffect(() => {
    if (renderedItems === null && configState.config.data) {
      setRenderedItems(listItems(setItemSelected, url, configState));
    }
  }, [renderedItems, configState.config.data]);
  //#endregion ------ useEffect ------

  return (
    <React.Fragment>
      <ContainerMenu
        $showBurguerMobile={showBurguerMobile}
        id={"ptur-burguerMobile-0706"}
      >
        <div onClick={onCloseBurguerMobile} className="fondo-abm" />
        {/* ZONA DEL LA IMAGEN DE TOP */}
        <TopMenu $isIos={isIOS}>
          <button className="btn-close" onClick={onCloseBurguerMobile}>
            <CrossLucideIcon color={"var(--color-white)"} />
          </button>
          <Link to={"/perfil"} className="profile-link">
            <Image
              id="PerfilImage"
              alt="Perfil"
              src={
                imgAvatar !== null &&
                imgAvatar !== undefined &&
                imgAvatar !== ""
                  ? `data:image/jpeg;base64,${imgAvatar}`
                  : defaultPerfil
              }
            />
            <TextTopMenu>
              <p className="profile-name">
                {authState?.auth?.data?.paciente?.nombre}
              </p>
              <span className="profile-action">
                Ver mi perfil
                <ChevronRightIcon color={"rgba(255, 255, 255, 0.8)"} />
              </span>
            </TextTopMenu>
          </Link>
        </TopMenu>
        {/* ZONA DEL LISTADO DE LOS ITEM */}
        <BodyMenu>
          {renderedItems !== null &&
            renderedItems.contents.map((content, index1) => {
              return (
                <ComboMenu key={index1}>
                  <h1>{renderedItems.titles[index1]}</h1>
                  <div className="line-white"></div>
                  <ul>
                    {content.map((item, index2) => {
                      const elementActive = Number.isInteger(
                        itemSelected[index1]
                      )
                        ? itemSelected[index1] === index2
                        : false;
                      return (
                        <li
                          key={index2}
                          className={elementActive ? "selected" : ""}
                          onClick={() => {
                            if (item.link === "/") {
                              onHandleSalir();
                            } else if (item.link === "*ayuda*") {
                              item.fun();
                            } else {
                              navigate(item);
                            }
                          }}
                        >
                          <Link
                            to={item.link === "*ayuda*" ? url : item.link}
                            onClick={(e) => {
                              e.preventDefault(); // Prevenir la navegación automática del Link
                            }}
                          >
                            <span className="iconBox">{item.icon}</span>
                            <span>{item.title}</span>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </ComboMenu>
              );
            })}
          {/* Redes sociales */}
          <SocialSidebar
            colorLink={"#fff"}
            cssCustom={"ptur-socialSidebar-burguer"}
          />
          {isIOS && <div className="ptur-burguerMobile-bottomFixIos"></div>}
          {isWebPlatform && (
            <div className="ptur-burguerMobile-bottomFixWebMobile"></div>
          )}
        </BodyMenu>
      </ContainerMenu>
    </React.Fragment>
  );
};

export default BurguerMobile;
